import React from 'react'

const ArrowRight = ({className}) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="17.967" height="17.967" viewBox="0 0 17.967 17.967" className={className}>
			<path className="a" d="M8.57,17.528l-8.1-7.487a1.418,1.418,0,0,1,0-2.117L8.57.438a1.716,1.716,0,0,1,2.29,0,1.42,1.42,0,0,1,0,2.118L5.533,7.481H16.348a1.561,1.561,0,0,1,1.619,1.5,1.562,1.562,0,0,1-1.619,1.5H5.523L10.86,15.41a1.42,1.42,0,0,1,0,2.118,1.712,1.712,0,0,1-2.29,0Z" transform="translate(17.967 17.967) rotate(180)"/>
	</svg>
)

export default ArrowRight;